import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, HelpCircle } from 'lucide-react';
import { mindsetDetailContent, siteConfig } from '../data';
import ScrollReveal from '../components/ScrollReveal';
import SEO from '../components/SEO';

export default function Mindsetforloeb() {
  const { title, text1, text2, relevantTitle, bullets, price, cta } = mindsetDetailContent;

  return (
    <div className="bg-white py-16 sm:py-24">
      <SEO 
        title="Personligt Mindsetforløb | Skab mental balance | SECoaching"
        description="Få mere klarhed, bryd begrænsende tanker og skab sunde vaner med et individuelt tilpasset mindsetforløb. Kontakt SECoaching og start din udvikling!"
      />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <div className="mb-8 flex items-center gap-2 text-sm text-slate-500">
          <Link to="/" className="hover:text-blue-900 transition-colors">Forside</Link>
          <span>/</span>
          <Link to="/forloeb-og-priser" className="hover:text-blue-900 transition-colors">Forløb og priser</Link>
          <span>/</span>
          <span className="text-blue-950 font-medium">{title}</span>
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 items-start">
          {/* Content Column */}
          <ScrollReveal direction="up" duration={800} className="space-y-8 lg:col-span-7">
            <h1 className="text-4xl font-extrabold tracking-tight text-blue-950 sm:text-5xl">
              {title}
            </h1>

            <div className="space-y-6 text-lg text-slate-600 leading-relaxed">
              <p className="font-medium text-blue-950">
                {text1}
              </p>
              <p>
                {text2}
              </p>
            </div>

            {/* Bullet Points Card */}
            <div className="space-y-6 pt-4">
              <h3 className="text-lg font-bold text-blue-950 flex items-center gap-2">
                <HelpCircle className="h-5 w-5 text-slate-900" />
                {relevantTitle}
              </h3>
              <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {bullets.map((bullet, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <Check className="h-5 w-5 text-slate-900 shrink-0 mt-0.5" />
                    <span className="text-sm font-medium text-slate-700">{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Pricing & CTA */}
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6 rounded-none border border-slate-100 bg-white p-6 shadow-lg shadow-slate-100/50">
              <div>
                <span className="block text-xs font-semibold text-slate-400 uppercase tracking-wider">Investering i dig selv</span>
                <span className="text-2xl font-extrabold text-blue-950">{price}</span>
              </div>
              <Link
                to="/kontakt"
                className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-none bg-blue-950 px-8 py-4 text-base font-bold text-white hover:bg-blue-900 hover:-translate-y-1 active:scale-98 transition-all duration-300"
              >
                {cta}
                <ArrowRight className="h-4 w-4 text-sky-400" />
              </Link>
            </div>
          </ScrollReveal>

          {/* Image & Info Column */}
          <ScrollReveal direction="up" duration={900} className="lg:col-span-5 space-y-8">
            <div className="relative">
              <div className="relative overflow-hidden rounded-none border border-slate-100 bg-white">
                <img
                  src={siteConfig.images.mindset}
                  alt="Mindset coaching session"
                  className="h-[350px] w-full object-cover sm:h-[450px] rounded-none shadow-md"
                />
              </div>
            </div>

            {/* What is included card */}
            <div className="rounded-none border border-slate-100 bg-white p-6 shadow-md space-y-4">
              <h4 className="font-bold text-blue-950">Hvad indebærer forløbet?</h4>
              <div className="space-y-3 text-sm text-slate-600">
                <div className="flex justify-between py-2 border-b border-slate-50">
                  <span className="font-medium">Format</span>
                  <span>1:1 samtaler (Online eller fysisk)</span>
                </div>
                <div className="flex justify-between py-2 border-b border-slate-50">
                  <span className="font-medium">Varighed</span>
                  <span>Tilpasses efter dine behov</span>
                </div>
                <div className="flex justify-between py-2 border-b border-slate-50">
                  <span className="font-medium">Mellem samtalerne</span>
                  <span>Konkrete øvelser og refleksioner</span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="font-medium">Support</span>
                  <span>E-mail support under hele forløbet</span>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
}
